import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

export default class Global extends Component {
  render() {
    const arr = [];
    for (let i = 1; i < 6; i++) {
      arr[i] = i;
    }
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/gameart">
                  Game Art Projects
                </Link>
              </Col>
              <Col span={24} className="projectTitle">
                Global Game Jam 2025
              </Col>
              <Col span={24} className="paddTop60"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row className="bgColorGray" justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row>
              <Col span={24} className="paddTop40 paddLR10">
                <Space direction="vertical" size="large">
                  <Image
                    alt={`Global Game 0 Image`}
                    src={`${process.env.PUBLIC_URL}/images/jpg/Global_0.jpg`}
                    className="img100"
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Global_0_blur.jpg`}
                        className="img100"
                        preview={false}
                      />
                    }
                  />
                  <div className="rH100">
                    <div className="colCenter">
                      <a
                        className="linkBtn"
                        href="https://wittydoma.itch.io/ggj2025"
                        target="_blank"
                      >
                        Play Link
                      </a>
                    </div>
                  </div>
                  {arr.map((item) => {
                    return (
                      <Image
                        alt={`Global Game ${item} Image`}
                        src={`${process.env.PUBLIC_URL}/images/jpg/Global_${item}.jpg`}
                        className="img100"
                        loading="lazy"
                        preview={false}
                        placeholder={
                          <Image
                            src={`${process.env.PUBLIC_URL}/images/jpg/Global_${item}_blur.jpg`}
                            className="img100"
                            preview={false}
                          />
                        }
                      />
                    );
                  })}
                </Space>
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row>
          <Col className="rH100"></Col>
        </Row>
      </>
    );
  }
}
